import { Component } from 'react';
import { connect } from 'react-redux';
import { If } from 'react-if';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Datatable from '../../common/datatable';
import { history } from '../../../store';
import { MODULE_LEVEL } from '../../../data/modules';
import ArrowButton from '../../common/button-arrow';
import Module from '../../common/module';

const columns = [
  {
    prop: 'customer-number',
    title: 'Customer Number',
    width: '150',
    format(data, row) {
      return (
        <div>
          { row.attributes['scan-invalidation-status'] === 'in_progress' && (
            <OverlayTrigger
              placement="left"
              overlay={(
                <Tooltip id="tooltip" className="tooltip">Invalidating scans in progress</Tooltip>
              )}
            >
              <span className="glyphicon glyphicon-refresh" aria-hidden="true" style={ {marginRight: '0.5em'} }></span>
            </OverlayTrigger>
          )}
          {data}
        </div>
      );
    }
  },
  {
    prop: 'name',
    title: 'Outlet Name'
  },
  {
    prop: 'staff-count',
    title: '# Staff',
    width: '70'
  },
  {
    prop: 'mini-chain',
    title: 'Mini Chain',
    width: '150',
    format(data) {
      return (
        <div className='mini-chain-column'>
          {data}
        </div>
      );
    }
  }
];

class OutletTable extends Component {
  render() {
    const actions = [
      {
        label: 'View',
        permissions: {
          action: 'manage',
          subjectClass: 'Outlet'
        },
        callback: (row) => {
          history.push(`/admin/outlets/${row.id}/view`);
        }
      },
      {
        label: 'Delink',
        color: 'grey',
        permissions: {
          action: 'delink',
          subjectClass: 'Outlet'
        },
        render: (cell, row) => row.attributes.linked,
        callback: (row) => {
          history.push(`/admin/outlets/${row.id}/delink`);
        }
      },
      (index, row) => {
        const permissions = {
          action: 'read',
          subjectClass: 'Level'
        };
        return (
          <Module key={index} name={MODULE_LEVEL}>
            <If condition={row.attributes.linked}>
              <ArrowButton
                arrow={false}
                block
                className="update-level-button"
                color="red"
                onClick={() => history.push(`/admin/update-level/${row.id}`)}
                permissions={permissions}
                submit={false}
              >
                Update level
              </ArrowButton>
            </If>
          </Module>
        );
      }
    ];

    const {outlets, paging} = this.props;
    return (

      <div>
        <Datatable
          actions={actions}
          columns={columns}
          data={outlets}
          dataSize={paging ? paging.number * paging.size : outlets.length}
          hideId={false}
          inlineActions={false}
          pagination={{
            page: this.props.currentPage,
            sizePerPage: 20,
            onPageChange: this.props.onPageChange,
          }}
          remote
        />
      </div>
    );
  }
}

export default connect()(OutletTable);
